import React from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'

import AddGroupMembershipsToUsersForm from '../../components/userAndGroupForms/AddGroupMembershipsToUsersForm/AddGroupMembershipsToUsersForm'
import useRoutes from '../../state/useRoutes'

export default React.memo(function AddGroupMembershipsToUserPage() {
  const { uuid } = useParams()

  const { close } = useOutletContext<any>()

  return <AddGroupMembershipsToUsersForm userUuids={[uuid!]} onClose={close} />
})

export function AddGroupMembershipsToUserPageBreadcrumb() {
  const { uuid } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.AddGroupMembershipsToUser.url({ uuid: uuid! })}>{t('manage group.add to group')}</Link>
}
